import React, { Component } from "react";
import PageTitle from "../Theme/PageTitle/index.js";
import { ConfigProvider,Table, Modal, Button } from "antd";
import DashboardLayout from "../Theme/DashboardLayout/index.js";
import dayjs from 'dayjs'
import _ from 'underscore';
import Spinner from '../Theme/Spinner/index.js';
import trueBlankDayTypeRequest from './utils/day-type-requests/trueBlankDayTypeRequest.js';
import DayTypeRequestUpdate from './DayTypeRequestsUpdate.js';
import SelectDayTypeResourceButton from './SelectDayTypeResource/SelectDayTypeResourceButton.js';
import * as dayTypeActions from '../../redux/actions/dayTypeActions.js';
import * as resourceActions from '../../redux/actions/resourceActions.js';
import { bindActionCreators } from "redux";
import AuthLogic from '../../AuthLogic/index.js';
import { connect } from 'react-redux';

class DayTypeCalendarView extends Component {
  constructor(props) {

    super(props);
    this.state = {
      widescreen: false,
      resource: '',
      dayTypeRequests: [],
      selectedDayTypeRequest: {},
      contextMenuKey: false,
      dayTypeDetailModal: false,
      dayTypeTable: {
        columns: [
          {
            key: '1',
            title: 'Day type',
            dataIndex: 'dayTypeName',
            render: text => <a>{text}</a>
          },
          {
            key: '2',
            title: 'From Date',
            dataIndex: 'fromDate',
            render: text => <a>{dayjs(text).format('MM/DD/YYYY')}</a>
          },
          {
            key: '3',
            title: 'To Date',
            dataIndex: 'toDate',
            render: text => <a>{dayjs(text).format('MM/DD/YYYY')}</a>
          },
          {
            key: '4',
            title: 'Status',
            dataIndex: 'status',
            render: text => <a>{text}</a>
          }
        ]
      },
      loaded: false
    }
  }

  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.readyApiCall();
  }

  readyApiCall = () => {
    let resource = {
      id: this.props.selectedDayTypeResource.id || this.props.user.login.resourceId,
      name: this.props.selectedDayTypeResource.name || this.props.user.userDemographics.name
    }
    this.setState({
      resource,
      loaded: false
    }, () => {
      console.log(`resourceName: ${this.state.resource.name}, resourceId: ${this.state.resource.id}`);
      this.getDataFromApi();
    });
  }

  getDataFromApi = async () => {
    const resourceId = this.state.resource.id || this.props.user.login.resourceId;
    const year = dayjs().year();
    const month = dayjs().month();
    const isApprover = AuthLogic.isApprover(this.props.user);
    let hasError = false;
    await this.props.actions.fetchDayTypesAll(isApprover, this.state.resource.id, dayjs().format('YYYY-MM-DD'))
      .catch(error => {
        if (!_.isEmpty(error)) {
          hasError = true;
          alert("Your STORM Resource account is not set up correctly; please contact the STORM Team.");
        }
      });

    if (hasError) {
      this.setState({ loaded: true });
      return;
    }

    await this.props.actions.fetchDayTypeRequestsByYear(resourceId, year, month)
      .catch(error => {
        console.log(error);
        alert("Your STORM Resource account is not set up correctly; please contact the STORM Team.");
      });
    let requestsWithKey = (await this.props.dayTypeRequests).map((request, index) => { return { ...request, key: index.toString() } });
    this.props.dayTypeRequests = requestsWithKey;
    this.setState({
      dayTypeRequests: await this.props.dayTypeRequests,
      loaded: true
    });
  }

  selectDayType = async (dayType) => {
    await this.props.actions.fetchDayTypeRequestById({ id: dayType.dayTypeRequestId });

    let dayTypeRequestInfo = this.props.dayTypeRequestInfo[0];
    let combinedDayType = { ...dayType };
    combinedDayType.fromTime = dayTypeRequestInfo.fromTime;
    combinedDayType.toTime = dayTypeRequestInfo.toTime;
    combinedDayType.status = dayTypeRequestInfo.status

    this.setState({
      selectedDayTypeRequest: await combinedDayType
    }, () => {
      this.showModal();
    })
  }

  resize = () => {
    if (window.innerWidth >= 990) {
      this.setState({
        widescreen: true
      });
    } else {
      this.setState({
        widescreen: false
      });
    }
  }

  showCreateModal = () => {
    this.setState({
      contextMenuKey: true,
      selectedDayTypeRequest: { ...trueBlankDayTypeRequest }
    }, () => {
      this.setState({
        dayTypeDetailModal: true
      });
    })
  }

  showModal = () => {
    this.setState({
      contextMenuKey: false
    }, () => {
      this.setState({
        dayTypeDetailModal: true
      });
    })
  }

  handleModalCancel = (e) => {
    this.setState({
      dayTypeDetailModal: false,
    });
  }


  render() {
    return (

      <DashboardLayout>
        <ConfigProvider
          theme={{
            components: {
              Table: {
                rowHoverBg:'#e0ffff',
                rowSelectedBg:'#e0ffff'
              },
            },
          }}>

        
        <PageTitle title={'Day Type Requests'} subTitle={this.state.resource.name || this.props.user.userDemographics.name} />
        {this.state.loaded
          ?
          <React.Fragment>
            <Table
              columns={this.state.dayTypeTable.columns}
              dataSource={this.state.dayTypeRequests}
              size='small'
              scroll={{ y: 240 }}
              

              pagination={{
                total: this.state.dayTypeRequests.length,
                pageSize: this.state.dayTypeRequests.length,
                hideOnSinglePage: true
              }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: () => { this.selectDayType(record) }
                };
              }}
            />

            {(AuthLogic.addDayTypeRequest(this.props.user) && this.props.user.mobileSecurity.canEdit == 3) && (
              <Button style={{ marginTop: 20 }} type="primary" size={'large'} htmlType="submit" onClick={this.showCreateModal}>
                Create Day Type Request
              </Button>
            )}

            <Modal
              zIndex={2000}
              title={'Day Type Request'}
              open={this.state.dayTypeDetailModal}
              onCancel={this.handleModalCancel} // the x in top right corner
              footer={[]}
              destroyOnHidden={true}
            >
              <DayTypeRequestUpdate
                readyApiCall={this.readyApiCall}
                selectedDayTypeRequest={this.state.selectedDayTypeRequest}
                handleModalCancel={this.handleModalCancel}
                contextMenuKey={this.state.contextMenuKey}
              />
            </Modal>
          </React.Fragment>
          :
          <Spinner />
        }
        {AuthLogic.changeAbsencesResource(this.props.user) &&
          (<SelectDayTypeResourceButton
            updatePageCallback={this.readyApiCall}
          />)
        }
        </ConfigProvider>
      </DashboardLayout>
      
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    resources: state.resources,
    selectedDayTypeResource: state.selectedDayTypeResource,
    dayTypeRequests: state.dayTypeRequestsByYear.dayTypeRequestsArray,
    dayTypeRequestInfo: state.dayTypeRequestInfo,
    ifHasHolidaySchedule: state.ifHasHolidaySchedule
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchDayTypeRequestsByYear: bindActionCreators(
        dayTypeActions.fetchDayTypeRequestsByYear,
        dispatch
      ),
      fetchDayTypeRequestById: bindActionCreators(
        dayTypeActions.fetchDayTypeRequestById,
        dispatch
      ),
      fetchDayTypesAll: bindActionCreators(
        dayTypeActions.fetchDayTypesAll,
        dispatch
      ),
      addDayType: bindActionCreators(
        dayTypeActions.createDayType,
        dispatch
      ),
      updateSelectedDayTypeResource: bindActionCreators(
        resourceActions.updateSelectedDayTypeResource,
        dispatch
      ),
      fetchIfHasHolidaySchedule: bindActionCreators(
        dayTypeActions.fetchIfHasHolidaySchedule,
        dispatch
      ),
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DayTypeCalendarView);
